(() => {
  const addScript = (src,id) => {
    if (document.getElementById(id)) return;
    const script=document.createElement('script');script.async=true;script.id=id;script.src=src;document.head.appendChild(script);
  };
  window.dataLayer=window.dataLayer||[];
  window.gtag=window.gtag||function(){window.dataLayer.push(arguments);};
  window.dataLayer.push({'gtm.start':Date.now(),event:'gtm.js'});
  addScript('https://www.googletagmanager.com/gtm.js?id=GTM-MKP3JNLV','spx-gtm');
  const loadSecondaryAnalytics=() => {
    if (document.getElementById('spx-ga4-secondary')) return;
    addScript('https://www.googletagmanager.com/gtag/js?id=G-KZPMLPRWBF','spx-ga4-secondary');
    window.gtag('js',new Date());
    window.gtag('config','G-KZPMLPRWBF',{send_page_view:true,linker:{domains:['signalpack.bunkerstore.jp','bunker.teefive.co.jp'],accept_incoming:true}});
    window.clarity=window.clarity||function(){(window.clarity.q=window.clarity.q||[]).push(arguments);};
    addScript('https://www.clarity.ms/tag/wyr939ybtu','spx-clarity');
  };
  const analyticsAllowed=() => !window.Shopify?.customerPrivacy || window.Shopify.customerPrivacy.analyticsProcessingAllowed();
  const maybeLoad=() => {if(analyticsAllowed())loadSecondaryAnalytics();};
  maybeLoad();
  document.addEventListener('visitorConsentCollected',maybeLoad);
})();
